// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelViewDetailsSkeleton-Value_cls1__P3UH6","cls2":"PaymentChannelViewDetailsSkeleton-Value_cls2__9F69G PaymentChannelViewDetailsSkeleton-Value_cls1__P3UH6"};